module.exports = __webpack_public_path__ + "resources/img/img-hyper-frame-tomcat-03-en.317cd98b95eddb3a0f9b5bd94525a8f2.png";